import {
  Box,
  makeStyles,
  Typography,
} from '@material-ui/core'
import { useState } from 'react'
import SelectionPDF from '../selectionPdf/SelectionPDF'
import {
  UIRegionOfInterest,
} from '../UIRegionOfInterest'
import SelectedColumnList from './selectedColumnsList/SelectedColumnsList'
import SaveButton from '../../../SaveButton'
import { S3Link } from '../../../../../shared/src/data/s3Link'

const useStyles = makeStyles((theme) => ({
  main: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    justifyContent: 'space-between',
  },
  loading: {
    marginTop: theme.spacing(1),
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}))

type ScheduleColumnSelectorProps = {
  saveExecutionParams: () => Promise<S3Link | undefined>
}

export default function ScheduleColumnSelector({saveExecutionParams}: ScheduleColumnSelectorProps): JSX.Element {
  const classes = useStyles()
  const [focusedRegionOfInterest, setFocusedRegionOfInterest] =
    useState<UIRegionOfInterest | null>(null)

  const [selectedPageNumber, setSelectedPageNumber] = useState<number>(1)
  return (
    <div>
      <Typography variant='subtitle1' color='textSecondary'>
        Select relevant columns. If there aren't any, click Next
      </Typography>
        <Box className={classes.main}>
          <Box className={classes.main} display='flex' flexWrap='wrap'>
            <SelectionPDF
              selectedPageNumber={selectedPageNumber}
              setSelectedPageNumber={setSelectedPageNumber}
              setFocusedRegionOfInterest={setFocusedRegionOfInterest}
              focusedRegionOfInterest={focusedRegionOfInterest}
            />
            <SelectedColumnList
              selectedPageNumber={selectedPageNumber}
              focusedRegionOfInterest={focusedRegionOfInterest}
              setFocusedRegionOfInterest={setFocusedRegionOfInterest}
              setSelectedPageNumber={setSelectedPageNumber}
            />
          </Box>
        </Box>
        <SaveButton saveExecutionParams={saveExecutionParams}/>
    </div>
  )
}
